import React from 'react';
import { Icon } from './Icon.js';
export const IconPhoto2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9.5 20L17 10.0001H18L22 15.0001", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M11 10.5C11 11.8807 9.88071 13 8.5 13C7.11929 13 6 11.8807 6 10.5C6 9.11929 7.11929 8 8.5 8C9.88071 8 11 9.11929 11 10.5Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M22 4H2V20H22V4Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconPhoto2.js.map